export const isHls = (src: string) => src.includes(".m3u8");

export const createHlsSourceElement = (src: string) => {
  const sourceElement = document.createElement("source");
  sourceElement.type = "application/x-mpegURL";
  sourceElement.src = src;

  return sourceElement;
};
